import { Controller } from "@hotwired/stimulus"
import Radar from 'radar-sdk-js';

// Connects to data-controller="map"
export default class extends Controller {
  static values = { 
    apikey: { type: String, default: "prj_live_pk_ff9f955aff49e30aa22bd736c59c30c621de43fa" }, 
    positions: { type: Array, default: [] }
  }

  connect() {    
    Radar.initialize(this.apikeyValue);

    this.map = Radar.ui.map({
      container: this.element,
      style: 'radar-default-v1',
      zoom: 14,
    });

    this.positionsValue.forEach(el => {
      this.addMarker(el)
    })
    this.map.fitToMarkers({ maxZoom: 14, padding: 80 });
  }

  addMarker(el) {
    Radar.ui.marker()
    .setLngLat(el)
    .addTo(this.map);
  }

  setPosition({ detail: { position }}) {
    this.positionsValue = [ position ]
    this.addMarker(position)

    this.map.fitToMarkers({ maxZoom: 14, padding: 80 });    
  }
}
